import { createContext, useContext } from 'react';
import { WorkspaceResponse } from '@/shared/api';

export type RouterSelectedCategory =
  | 'discover'
  | 'myProcs'
  | 'myInstances'
  | 'knowledgeBase';

type RouterPrivateContextType = {
  selectedCategory?: RouterSelectedCategory;
  setSelectedCategory: (category: RouterSelectedCategory) => void;
  selectedWorkspace?: WorkspaceResponse | undefined;
  setSelectedWorkspace: (workspace: WorkspaceResponse | undefined) => void;
};

export const RouterPrivateContext = createContext(
  {} as RouterPrivateContextType,
);

export const useRouterPrivateContext = () => {
  const context = useContext(RouterPrivateContext);
  if (context === undefined) {
    throw new Error(
      'useDashboardContext must be used within DashboardContext Provider',
    );
  }
  return context;
};
